import React from 'react';
import { useTheme } from '../components/ThemeContext';

export const TermsOfService: React.FC = () => {
  const { theme } = useTheme();
  const textCls = theme === 'dark' ? 'text-theme-secondary' : 'text-gray-800';
  const subCls = theme === 'dark' ? 'text-theme-muted' : 'text-gray-600';
  const hCls = theme === 'dark' ? 'text-theme-primary' : 'text-gray-900';

  return (
    <main className={`max-w-3xl mx-auto px-4 md:px-6 py-6 md:py-10 ${textCls}`}>
      <h1 className={`text-3xl font-bold mb-2 ${hCls}`}>Terms of Service</h1>
      <p className={`${subCls} text-sm mb-8`}>Last Updated: {new Date().getFullYear()}</p>

      <section className="space-y-6">
        <p>
          These Terms of Service ("Terms") govern your access to and use of the websites, products, and services
          (collectively, the "Services") provided by Stock Fortress, Inc ("Stock Fortress," "we," "us," or "our"). By
          accessing or using the Services, you agree to be bound by these Terms and our Privacy Policy.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>1. Eligibility and Account</h2>
        <p>
          You must be at least 18 years old and capable of forming a binding contract to use the Services. When you
          create an account, you must provide accurate information and keep it up to date. You are responsible for all
          activities that occur under your account and for keeping your password secure.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>2. Use of the Services</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Do not misuse the Services or interfere with their normal operation.</li>
          <li>Do not attempt to access accounts or data without authorization.</li>
          <li>Do not resell or redistribute data except as expressly permitted by us.</li>
        </ul>

        <h2 className={`text-xl font-semibold ${hCls}`}>3. Subscriptions and Billing</h2>
        <p>
          Some features require a paid subscription. If you purchase a subscription, you authorize Stock Fortress (and
          our payment processor) to charge your payment method. Subscriptions automatically renew unless you cancel
          before the end of the current billing cycle. Any applicable taxes will be charged in addition to fees.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>4. Cancellation and Refunds</h2>
        <p>
          You may cancel your subscription at any time in your account settings. Unless otherwise stated, fees are
          non-refundable; however, we may consider refund requests on a case-by-case basis where required by law.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>5. Market Data and Content</h2>
        <p>
          Information, research, and market data provided through the Services are for informational purposes only and
          do not constitute investment advice. Stock Fortress does not guarantee the accuracy, completeness, or
          timeliness of any information and assumes no liability for reliance on such information. You are solely
          responsible for your investment decisions.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>6. Intellectual Property</h2>
        <p>
          The Services, including all software, text, images, graphics, and other content, are owned by Stock Fortress
          or its licensors and are protected by intellectual property laws. Subject to these Terms, we grant you a
          limited, non-exclusive, non-transferable license to use the Services for your personal, non-commercial use.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>7. Disclaimers</h2>
        <p>
          THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED,
          INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
          NON-INFRINGEMENT. STOCK FORTRESS DOES NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>8. Limitation of Liability</h2>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, STOCK FORTRESS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
          SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR
          INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR ACCESS TO OR
          USE OF THE SERVICES.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>9. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless Stock Fortress and its affiliates, officers, agents, and employees
          from any claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out
          of or in any way connected with your access to or use of the Services or your violation of these Terms.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>10. Termination</h2>
        <p>
          We may suspend or terminate your access to the Services at any time, with or without cause or notice. Upon
          termination, the rights granted to you under these Terms will immediately cease.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>11. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the jurisdiction in which Stock Fortress is established, without
          regard to conflict of law principles.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>12. Changes to the Terms</h2>
        <p>
          We may modify these Terms from time to time. The updated Terms will be posted on this page with the "Last
          Updated" date above. Your continued use of the Services after changes become effective constitutes acceptance
          of the revised Terms.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>13. Contact Us</h2>
        <p>
          If you have questions about these Terms, please contact us at{' '}
          <a className="underline" href="mailto:support@stockfortress.com">support@stockfortress.com</a>.
        </p>
      </section>
    </main>
  );
};

export default TermsOfService;
